import JSONApi from "devour-client";
import store from "@/store";
import {
  isUnauthorized,
  HTTP_UNAUTHORIZED_MESSAGE
} from "@/utils/requestUtils";
import {
  clearLocalStorageItems,
  getAuthLogoutUrl
} from "@/services/APIService";
import { SET_AUTH_DIALOG_VISIBILITY } from "@/store/modules/global/mutation-types";
import { fromAuth } from "@/store/modules/auth";
import { SET_PERMISSIONS } from "@/store/modules/auth/mutation-types";
import { has, includes, get } from "lodash";
import bookingModel, {
  BOOKING_MODEL,
  bookingModelActions
} from "@/models/booking-model";
import addressModel, { ADDRESS_MODEL } from "@/models/address-model";
import fieldNecessityModel, {
  FIELD_NECESSITY_MODEL
} from "@/models/field-necessity-model";
import userModel, {
  USER_MODEL,
  USER_SELF_MODEL,
  USER_STAFF_MODEL,
  INVITE_USER
} from "@/models/user-model";
import userRoleModel, { USER_ROLE_MODEL } from "@/models/user-role-model";
import roleModel, { ROLE_MODEL } from "@/models/role-model";
import applicationModel, {
  APPLICATION_MODEL,
  applicationActions
} from "@/models/application-model";
import commentModel, { COMMENT_MODEL } from "@/models/comment-model";
import eventModel, { EVENT_MODEL } from "@/models/event-model";
import summaryModel, { SUMMARY_MODEL } from "@/models/summary-model";
import bookingTemplateModel, {
  BOOKING_TEMPLATE_MODEL
} from "@/models/booking-template-model";
import organisationModel, {
  ORGANISATION_MODEL,
  ORGANISATIONS_MODEL,
  INTERMEDIARY_COMPANY_MODEL,
  organisationModelActions
} from "@/models/organisation-model";
import hireReasonModel, { HIRE_REASON_MODEL } from "@/models/hire-reason-model";
import agencyModel, { AGENCY_MODEL } from "@/models/agency-model";
import publishingScheduleModel, {
  PUBLISHING_SCHEDULE_MODEL
} from "@/models/publishing-schedule-model";
import scheduleTierModel, {
  SCHEDULE_TIER_MODEL
} from "@/models/schedule-tier-model";
import publishingScheduleTemplateModel, {
  PUBLISHING_SCHEDULE_TEMPLATE_MODEL
} from "@/models/publishing-schedule-template-model";
import assessmentModel, { ASSESSMENT_MODEL } from "@/models/assessment-model";
import referenceModel, { REFERENCE_MODEL } from "@/models/reference-model";
import fileModel, { FILE_MODEL } from "@/models/file-model";
import {
  reportModel,
  reportFieldModel,
  reportFilterModel,
  reportGroupingModel,
  reportChartModel,
  reportSharedWithUserModel,
  REPORT_MODEL,
  REPORT_CHART_MODEL,
  REPORT_FIELD_MODEL,
  REPORT_FILTER_MODEL,
  REPORT_GROUPING_MODEL,
  REPORT_SHARED_WITH_USER_MODEL
} from "@/models/report-model";
import bookingApproverModel, {
  BOOKING_APPROVER_MODEL
} from "@/models/booking-approver-model";
import countryModel, { COUNTRY_MODEL } from "@/models/country-model";
import userSettingsModel, {
  USER_SETTINGS_MODEL
} from "@/models/user-settings-model";
import notificationModel, {
  NOTIFICATION_MODEL
} from "@/models/notifications/notification-model";
import emailNotificationsModel, {
  EMAIL_NOTIFICATIONS_MODEL
} from "@/models/notifications/emails/email-notifications-model";
import applicationNotificationsModel, {
  APPLICATION_NOTIFICATIONS_MODEL
} from "@/models/notifications/emails/application-notifications-model";
import bookingNotificationsModel, {
  BOOKING_NOTIFICATIONS_MODEL
} from "@/models/notifications/emails/booking-notifications-model";
import commentNotificationsModel, {
  COMMENT_NOTIFICATIONS_MODEL
} from "@/models/notifications/emails/comment-notifications-model";
import requirementModel, {
  REQUIREMENT_MODEL
} from "@/models/requirement-model";
import tagModel, { TAG_MODEL } from "@/models/tag-model";
import costCategoryModel, { COST_CATEGORY } from "@/models/cost-category-model";
import templateCostModel, {
  TEMPLATE_COST_MODEL
} from "@/models/template-cost-model";
import interviewSlotModel, {
  INTERVIEW_SLOT_MODEL,
  INTERVIEW_SLOTS_UNFILLED_MODEL
} from "@/models/interview-slot-model";
import interviewFormatTemplateModel, {
  INTERVIEW_FORMAT_TEMPLATE_MODEL
} from "@/models/interview-format-template-model";
import interviewFormatModel, {
  INTERVIEW_FORMAT_MODEL
} from "@/models/interview-format-model";
import selfScheduleSlotModel, {
  INTERVIEW_FORMAT_SELF_SCHEDULE_SLOT,
  SELF_SCHEDULE_SELECT_SLOT
} from "@/models/self-schedule-slot-model";
import interviewParticipantModel, {
  INTERVIEW_PARTICIPANT_MODEL
} from "@/models/interview-participant-model";
import rescheduleSlotModel, {
  RESCHEDULE_SLOT_MODEL
} from "@/models/reschedule-slot-model";
import interviewFeedbackModel, {
  INTERVIEW_FEEDBACK_MODEL
} from "@/models/interview-feedback-model";
import interviewFeedbackScoreModel, {
  INTERVIEW_FEEDBACK_SCORE_MODEL
} from "@/models/interview-feedback-score-model";
import interviewFormatCriteriaModel, {
  INTERVIEW_FORMAT_CRITERIA_MODEL
} from "@/models/interview-format-criteria-model";
import conversationModel, {
  CONVERSATION_MODEL
} from "@/models/conversation-model";
import conversationMessageModel, {
  CONVERSATION_MESSAGE_MODEL
} from "@/models/conversation-message-model";
import messageTemplateModel, {
  MESSAGE_TEMPLATE_MODEL
} from "@/models/message-template-model";
import applicationAnswerModel, {
  BOOKING_APPLICATION_QUESTIONS_ANSWER_MODEL
} from "@/models/application-answer-model";
import qualificationModel, {
  QUALIFICATION_MODEL
} from "@/models/qualification-model";
import experienceModel, { EXPERIENCE_MODEL } from "@/models/experience-model";
import reasonsForLeavingModel, {
  REASONS_FOR_LEAVING_MODEL
} from "@/models/reasons-for-leaving-model";
import experienceFunctionModel, {
  EXPERIENCE_FUNCTION_MODEL
} from "@/models/experience-function-model";
import sexualOrientationModel, {
  SEXUAL_ORIENTATION_MODEL
} from "@/models/sexual-orientation-model";
import religionModel, { RELIGION_MODEL } from "@/models/religion-model";
import maritalStatusModel, {
  MARITAL_STATUS_MODEL
} from "@/models/marital-status-model";
import { getToken, getImpersonateUserId } from "@/services/utils";
import { NS_SET_API_AVAILABILITY } from "@/store/modules/layout/mutation-types";
import workingHoursModel, {
  WORKING_HOURS_MODEL
} from "@/models/working-hours-model";
import workingHoursGroupingModel, {
  WORKING_HOURS_GROUPING_MODEL
} from "@/models/working-hours-grouping-model";
import locationGroupingModel, {
  LOCATION_GROUPING_MODEL
} from "@/models/location-grouping-model";
import jobPreferenceModel, {
  JOB_PREFERENCE_MODEL
} from "@/models/job-preference-model";
import ethnicGroupModel, {
  ETHNIC_GROUP_MODEL
} from "@/models/ethnic-group-model";
import ethnicGroupCategoryModel, {
  ETHNIC_GROUP_CATEGORY_MODEL
} from "@/models/ethnic-group-category-model";
import languageModel, { LANGUAGE_MODEL } from "@/models/language-model";
import languageLevelModel, {
  LANGUAGE_LEVEL_MODEL
} from "@/models/language-level-model";
import skillModel, { SKILL_MODEL } from "@/models/skill-model";
import skillLevelModel, { SKILL_LEVEL_MODEL } from "@/models/skill-level-model";
import diversityTraitModel, {
  DIVERSITY_TRAIT_MODEL
} from "@/models/diversity-trait-model";
import evaluationStatusModel, {
  EVALUATION_STATUS_MODEL
} from "@/models/evaluation-status-model";
import offerModel, { OFFER_MODEL, offerActions } from "@/models/offer-model";
import offerGroupModel, { OFFER_GROUP_MODEL } from "@/models/offer-group-model";
import offerGroupDocumentModel, {
  OFFER_GROUP_DOCUMENT_MODEL
} from "@/models/offer-group-document-model";
import offerGroupDocumentTemplateModel, {
  OFFER_GROUP_DOCUMENT_TEMPLATE_MODEL
} from "@/models/offer-group-document-template-model";
import todoModel, { TODO_MODEL } from "@/models/todo-model";
import refereeModel, { REFEREE_MODEL } from "@/models/referee-model";
import publishingChannelModel, {
  PUBLISHING_CHANNEL_MODEL
} from "@/models/publishing-channel-model";
import contractTypeModel, {
  CONTRACT_TYPE_MODEL
} from "@/models/contract-type-model";
import gradeModel, { GRADE_MODEL } from "@/models/grade-model";
import interviewInvitationModel, {
  INTERVIEW_INVITATION_MODEL
} from "@/models/interview-invitation-model";
import selfScheduleInviteModel, {
  SELF_SCHEDULE_INVITE_MODEL
} from "@/models/self-schedule-invite-model";
import bookingApplicationQuestionModel, {
  BOOKING_APPLICATION_QUESTION_MODEL
} from "@/models/booking-application-question-model";
import taxonomyModel, { TAXONOMY_MODEL } from "@/models/taxonomy-model";
import shareModel, { SHARE_MODEL } from "@/models/share-model";
import talentPoolModel, { TALENT_POOL_MODEL } from "@/models/talent-pool-model";
import matchModel, { MATCH_MODEL } from "@/models/match-model";
import offerGroupTemplateModel, {
  OFFER_GROUP_TEMPLATE_MODEL,
  COPY
} from "@/models/offer-group-template-model";
import contractTypesGroupingModel, {
  CONTRACT_TYPES_GROUPING_MODEL
} from "@/models/contract-types-grouping-model";
import bookingOptionModel, {
  BOOKING_OPTION_MODEL
} from "@/models/booking-option-model";
import bookingApplicationQuestionOptionModel, {
  BOOKING_APPLICATION_QUESTION_OPTION_MODEL
} from "@/models/booking-application-question-option-model";
import offerContractModel, {
  OFFER_CONTRACT,
  offerContractActions
} from "@/models/offer-contract-model";
import applicationQuestionTemplateModel, {
  APPLICATION_QUESTION_TEMPLATE_MODEL
} from "@/models/application-question-template-model";
import applicationQuestionOptionTemplateModel, {
  APPLICATION_QUESTION_OPTION_TEMPLATE_MODEL
} from "@/models/application-question-option-template-model";
import approvalChainTemplateModel, {
  APPROVAL_CHAIN_TEMPLATE_MODEL
} from "@/models/approval-chain-template-model";
import approvalChainTemplateLevelModel, {
  APPROVAL_CHAIN_TEMPLATE_LEVEL_MODEL
} from "@/models/approval-chain-template-level-model";
import micrositeModel, { MICROSITE_MODEL } from "@/models/microsite-model";
import micrositePageModel, {
  MICROSITE_PAGE_MODEL
} from "@/models/microsite-page-model";
import approvalChainTemplateLevelUserModel, {
  APPROVAL_CHAIN_TEMPLATE_LEVEL_USER_MODEL
} from "@/models/approval-chain-template-level-user-model";
import { NS_SET_API_ERROR } from "@/store/modules/auth/mutation-types";
import exportModel, { EXPORT_MODEL } from "@/models/export-model";
import userExportModel, { USER_EXPORT_MODEL } from "@/models/user-export-model";

const NESTED_DATA_TYPES = [
  "bookings",
  "conversations",
  "publishing-schedules",
  "references"
];
const SELF_DETAILS_ENDPOINT = "self";

const shouldPermissionsBeNested = data => {
  return typeof data === "object" && includes(NESTED_DATA_TYPES, data.type);
};

const manageActionForUnauthorizedUser = () => {
  clearLocalStorageItems();
  window.location.href = getAuthLogoutUrl();
};

const formatToNestedPermissions = entity =>
  Object.fromEntries(
    Object.entries(entity.meta.permissions).map(([permission, isPermitted]) => {
      const [section, ...nestedOperation] = permission.split(".");
      const operation = nestedOperation.join(".");
      if (operation) {
        return [`${section}[${entity.id}].${operation}`, isPermitted];
      }
      return [`${section}[${entity.id}]`, isPermitted];
    })
  );

const jsonApi = commit => {
  const token = getToken();
  const jsonApi = new JSONApi({
    apiUrl: `${process.env.VUE_APP_API_URL}/api/v1`,
    bearer: token,
    logger: false
  });
  store.commit(NS_SET_API_AVAILABILITY, false);
  store.commit(NS_SET_API_ERROR, false);
  jsonApi.define(BOOKING_MODEL, bookingModel);
  bookingModelActions.forEach(action => jsonApi.define(action, bookingModel));
  jsonApi.define(ADDRESS_MODEL, addressModel);
  jsonApi.define(USER_MODEL, userModel);
  jsonApi.define(USER_SELF_MODEL, userModel);
  jsonApi.define(USER_STAFF_MODEL, userModel);
  jsonApi.define(INVITE_USER, userModel);
  Object.values(applicationActions).forEach(variant =>
    jsonApi.define(variant, applicationModel)
  );
  jsonApi.define(APPLICATION_MODEL, applicationModel);
  jsonApi.define(COMMENT_MODEL, commentModel);
  jsonApi.define(BOOKING_TEMPLATE_MODEL, bookingTemplateModel);
  jsonApi.define(EVENT_MODEL, eventModel);
  jsonApi.define(SUMMARY_MODEL, summaryModel);
  Object.values(organisationModelActions).forEach(variant =>
    jsonApi.define(variant, organisationModel)
  );
  jsonApi.define(ORGANISATION_MODEL, organisationModel);
  jsonApi.define(ORGANISATIONS_MODEL, organisationModel);
  jsonApi.define(INTERMEDIARY_COMPANY_MODEL, organisationModel);
  jsonApi.define(HIRE_REASON_MODEL, hireReasonModel);
  jsonApi.define(PUBLISHING_SCHEDULE_MODEL, publishingScheduleModel);
  jsonApi.define(SCHEDULE_TIER_MODEL, scheduleTierModel);
  jsonApi.define(
    PUBLISHING_SCHEDULE_TEMPLATE_MODEL,
    publishingScheduleTemplateModel
  );
  jsonApi.define(ASSESSMENT_MODEL, assessmentModel);
  jsonApi.define(REFERENCE_MODEL, referenceModel);
  jsonApi.define(FILE_MODEL, fileModel);
  jsonApi.define(REPORT_MODEL, reportModel);
  jsonApi.define(REPORT_FIELD_MODEL, reportFieldModel);
  jsonApi.define(REPORT_FILTER_MODEL, reportFilterModel);
  jsonApi.define(REPORT_GROUPING_MODEL, reportGroupingModel);
  jsonApi.define(REPORT_CHART_MODEL, reportChartModel);
  jsonApi.define(BOOKING_APPROVER_MODEL, bookingApproverModel);
  jsonApi.define(COUNTRY_MODEL, countryModel);
  jsonApi.define(USER_SETTINGS_MODEL, userSettingsModel);
  jsonApi.define(NOTIFICATION_MODEL, notificationModel);
  jsonApi.define(EMAIL_NOTIFICATIONS_MODEL, emailNotificationsModel);
  jsonApi.define(
    APPLICATION_NOTIFICATIONS_MODEL,
    applicationNotificationsModel
  );
  jsonApi.define(BOOKING_NOTIFICATIONS_MODEL, bookingNotificationsModel);
  jsonApi.define(COMMENT_NOTIFICATIONS_MODEL, commentNotificationsModel);
  jsonApi.define(USER_ROLE_MODEL, userRoleModel);
  jsonApi.define(ROLE_MODEL, roleModel);
  jsonApi.define(AGENCY_MODEL, agencyModel);
  jsonApi.define(FIELD_NECESSITY_MODEL, fieldNecessityModel);
  jsonApi.define(REQUIREMENT_MODEL, requirementModel);
  jsonApi.define(TAG_MODEL, tagModel);
  jsonApi.define(COST_CATEGORY, costCategoryModel);
  jsonApi.define(TEMPLATE_COST_MODEL, templateCostModel);
  jsonApi.define(INTERVIEW_SLOT_MODEL, interviewSlotModel);
  jsonApi.define(INTERVIEW_SLOTS_UNFILLED_MODEL, interviewSlotModel);
  jsonApi.define(INTERVIEW_FORMAT_TEMPLATE_MODEL, interviewFormatTemplateModel);
  jsonApi.define(INTERVIEW_FORMAT_MODEL, interviewFormatModel);
  jsonApi.define(INTERVIEW_FORMAT_SELF_SCHEDULE_SLOT, selfScheduleSlotModel);
  jsonApi.define(SELF_SCHEDULE_SELECT_SLOT, selfScheduleSlotModel);
  jsonApi.define(INTERVIEW_PARTICIPANT_MODEL, interviewParticipantModel);
  jsonApi.define(RESCHEDULE_SLOT_MODEL, rescheduleSlotModel);
  jsonApi.define(INTERVIEW_FEEDBACK_MODEL, interviewFeedbackModel);
  jsonApi.define(INTERVIEW_FEEDBACK_SCORE_MODEL, interviewFeedbackScoreModel);
  jsonApi.define(INTERVIEW_FORMAT_CRITERIA_MODEL, interviewFormatCriteriaModel);
  jsonApi.define(CONVERSATION_MESSAGE_MODEL, conversationMessageModel);
  jsonApi.define(CONVERSATION_MODEL, conversationModel);
  jsonApi.define(MESSAGE_TEMPLATE_MODEL, messageTemplateModel);
  jsonApi.define(
    BOOKING_APPLICATION_QUESTIONS_ANSWER_MODEL,
    applicationAnswerModel
  );
  jsonApi.define(QUALIFICATION_MODEL, qualificationModel);
  jsonApi.define(EXPERIENCE_MODEL, experienceModel);
  jsonApi.define(REASONS_FOR_LEAVING_MODEL, reasonsForLeavingModel);
  jsonApi.define(EXPERIENCE_FUNCTION_MODEL, experienceFunctionModel);
  jsonApi.define(SEXUAL_ORIENTATION_MODEL, sexualOrientationModel);
  jsonApi.define(RELIGION_MODEL, religionModel);
  jsonApi.define(MARITAL_STATUS_MODEL, maritalStatusModel);
  jsonApi.define(WORKING_HOURS_MODEL, workingHoursModel);
  jsonApi.define(WORKING_HOURS_GROUPING_MODEL, workingHoursGroupingModel);
  jsonApi.define(LOCATION_GROUPING_MODEL, locationGroupingModel);
  jsonApi.define(JOB_PREFERENCE_MODEL, jobPreferenceModel);
  jsonApi.define(ETHNIC_GROUP_MODEL, ethnicGroupModel);
  jsonApi.define(ETHNIC_GROUP_CATEGORY_MODEL, ethnicGroupCategoryModel);
  jsonApi.define(LANGUAGE_MODEL, languageModel);
  jsonApi.define(SKILL_MODEL, skillModel);
  jsonApi.define(LANGUAGE_LEVEL_MODEL, languageLevelModel);
  jsonApi.define(SKILL_LEVEL_MODEL, skillLevelModel);
  jsonApi.define(DIVERSITY_TRAIT_MODEL, diversityTraitModel);
  jsonApi.define(EVALUATION_STATUS_MODEL, evaluationStatusModel);
  jsonApi.define(OFFER_MODEL, offerModel);
  offerActions.forEach(action => jsonApi.define(action, offerModel));
  jsonApi.define(OFFER_GROUP_MODEL, offerGroupModel);
  jsonApi.define(OFFER_GROUP_DOCUMENT_MODEL, offerGroupDocumentModel);
  jsonApi.define(
    OFFER_GROUP_DOCUMENT_TEMPLATE_MODEL,
    offerGroupDocumentTemplateModel
  );
  jsonApi.define(TODO_MODEL, todoModel);
  jsonApi.define(REFEREE_MODEL, refereeModel);
  jsonApi.define(PUBLISHING_CHANNEL_MODEL, publishingChannelModel);
  jsonApi.define(CONTRACT_TYPE_MODEL, contractTypeModel);
  jsonApi.define(GRADE_MODEL, gradeModel);
  jsonApi.define(CONTRACT_TYPES_GROUPING_MODEL, contractTypesGroupingModel);
  jsonApi.define(INTERVIEW_INVITATION_MODEL, interviewInvitationModel);
  jsonApi.define(SELF_SCHEDULE_INVITE_MODEL, selfScheduleInviteModel);
  jsonApi.define(
    BOOKING_APPLICATION_QUESTION_MODEL,
    bookingApplicationQuestionModel
  );
  jsonApi.define(TAXONOMY_MODEL, taxonomyModel);
  jsonApi.define(SHARE_MODEL, shareModel);
  jsonApi.define(TALENT_POOL_MODEL, talentPoolModel);
  jsonApi.define(MATCH_MODEL, matchModel);
  jsonApi.define(OFFER_GROUP_TEMPLATE_MODEL, offerGroupTemplateModel);
  jsonApi.define(COPY, offerGroupTemplateModel);
  jsonApi.define(BOOKING_OPTION_MODEL, bookingOptionModel);
  jsonApi.define(OFFER_CONTRACT, offerContractModel);
  jsonApi.define(
    BOOKING_APPLICATION_QUESTION_OPTION_MODEL,
    bookingApplicationQuestionOptionModel
  );
  jsonApi.define(
    APPLICATION_QUESTION_TEMPLATE_MODEL,
    applicationQuestionTemplateModel
  );
  jsonApi.define(
    APPLICATION_QUESTION_OPTION_TEMPLATE_MODEL,
    applicationQuestionOptionTemplateModel
  );
  offerContractActions.forEach(action =>
    jsonApi.define(action, offerContractModel)
  );
  jsonApi.define(APPROVAL_CHAIN_TEMPLATE_MODEL, approvalChainTemplateModel);
  jsonApi.define(
    APPROVAL_CHAIN_TEMPLATE_LEVEL_MODEL,
    approvalChainTemplateLevelModel
  );
  jsonApi.define(
    APPROVAL_CHAIN_TEMPLATE_LEVEL_USER_MODEL,
    approvalChainTemplateLevelUserModel
  );
  jsonApi.define(REPORT_SHARED_WITH_USER_MODEL, reportSharedWithUserModel);
  jsonApi.define(MICROSITE_MODEL, micrositeModel);
  jsonApi.define(MICROSITE_PAGE_MODEL, micrositePageModel);
  jsonApi.define(EXPORT_MODEL, exportModel);
  jsonApi.define(USER_EXPORT_MODEL, userExportModel);

  const requestMiddleware = {
    name: "add-id-to-request-data",
    req: payload => {
      if (payload.req.method === "PATCH") {
        const id = payload.req.url.split("/").pop();
        payload.req.data.data.id = id;
      }
      return payload;
    }
  };

  const errorMiddleware = {
    name: "errors",
    error: payload => {
      if (isUnauthorized(payload ? payload.response : payload)) {
        const url = get(payload, "response.config.url");
        const isAlreadyLoggedIn = getToken();
        if (includes(url, SELF_DETAILS_ENDPOINT) && isAlreadyLoggedIn) {
          return manageActionForUnauthorizedUser();
        }
        store.commit(SET_AUTH_DIALOG_VISIBILITY, true);
        return {
          message: HTTP_UNAUTHORIZED_MESSAGE
        };
      }
      if (payload && payload.response && payload.response.data) {
        const { status } = payload.response;
        if (status && status === 500) {
          store.commit(NS_SET_API_ERROR, true);
        } else {
          store.commit(NS_SET_API_ERROR, false);
        }
        return payload.response.data;
      } else {
        store.commit(NS_SET_API_AVAILABILITY, true);
      }
      throw payload;
    }
  };
  jsonApi.insertMiddlewareBefore("axios-request", requestMiddleware);
  jsonApi.replaceMiddleware("errors", errorMiddleware);
  jsonApi.insertMiddlewareBefore("response", {
    name: "permissions",
    res: payload => {
      const body = payload.res.data.data;
      if (has(body, "meta.permissions")) {
        let permissions = body.meta.permissions;
        if (shouldPermissionsBeNested(body)) {
          permissions = formatToNestedPermissions(body);
        }
        commit(fromAuth(SET_PERMISSIONS), permissions, {
          root: true
        });
      } else if (has(body, "[0].meta.permissions")) {
        body.forEach(entity => {
          if (has(entity, "meta.permissions")) {
            const permissions = formatToNestedPermissions(entity);
            commit(fromAuth(SET_PERMISSIONS), permissions, {
              root: true
            });
          }
        });
      }
      return payload;
    }
  });

  jsonApi.errorBuilder = error => {
    const { title, detail, meta } = error;
    return { title, detail, meta };
  };

  jsonApi.headers["Accept"] = "application/json";

  const impersonateUserId = getImpersonateUserId();
  if (impersonateUserId) {
    jsonApi.headers["X-Impersonate"] = impersonateUserId;
  }

  return jsonApi;
};

export default jsonApi;
